import * as React from 'react'
import { languageSwitch } from './languageSwitch'

export const topNavBar = (open: boolean) => {
  return (
    <div className="top-nav">
      <nav className="nav nav--top">
        <div className="nav__inner">
          <ul className="nav__list container container--m grid--gutter">
            <li className="nav__item">
              <a className="nav__link" href="/">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </nav>
      {languageSwitch(false)}
    </div>
  )
}
